export const SAVE_TAX_RATE_TEMPLATE_REQUEST =
  'tax-rates/save-tax-rate-template-request';
export const SAVE_TAX_RATE_TEMPLATE_SUCCESS =
  'tax-rates/save-tax-rate-template-success';
export const SAVE_TAX_RATE_TEMPLATE_FAILURE =
  'tax-rates/save-tax-rate-template-failure';

export const GET_TAX_RATE_TEMPLATES_REQUEST =
  'tax-rates/get-tax-rate-templates-request';
export const GET_TAX_RATE_TEMPLATES_SUCCESS =
  'tax-rates/get-tax-rate-templates-success';
export const GET_TAX_RATE_TEMPLATES_FAILURE =
  'tax-rates/get-tax-rate-templates-failure';

export const DELETE_TAX_RATE_TEMPLATE_REQUEST =
  'tax-rates/delete-tax-rate-template-request';
export const DELETE_TAX_RATE_TEMPLATE_SUCCESS =
  'tax-rates/delete-tax-rate-template-success';
export const DELETE_TAX_RATE_TEMPLATE_FAILURE =
  'tax-rates/delete-tax-rate-template-failure';

export const EDIT_TAX_RATE_TEMPLATE_NAME_REQUEST =
  'tax-rates/edit-tax-rate-template-name-request';
export const EDIT_TAX_RATE_TEMPLATE_NAME_SUCCESS =
  'tax-rates/edit-tax-rate-template-name-success';
export const EDIT_TAX_RATE_TEMPLATE_NAME_FAILURE =
  'tax-rates/edit-tax-rate-template-name-failure';

export const FETCH_TAX_RATES_BY_COUNTRY_REQUEST =
  'tax-rates/fetch-tax-rates-by-country-request';
export const FETCH_TAX_RATES_BY_COUNTRY_SUCCESS =
  'tax-rates/fetch-tax-rates-by-country-success';
export const FETCH_TAX_RATES_BY_COUNTRY_FAILURE =
  'tax-rates/fetch-tax-rates-by-country-failure';

export const SAVE_TAX_RATES_REQUEST = 'tax-rates/save-tax-rates-request';
export const SAVE_TAX_RATES_SUCCESS = 'tax-rates/save-tax-rates-success';
export const SAVE_TAX_RATES_FAILURE = 'tax-rates/save-tax-rates-failure';

// Refresh tax rates for a single connection (lightweight helper)
export const REFRESH_CONNECTION_TAX_RATES_REQUEST =
  'tax-rates/refresh-connection-tax-rates-request';

export const SET_GETTING_TAXES = 'tax-rates/set-getting-taxes';

export const DELETE_EXCEL_TAX_RATE_REQUEST =
  'tax-rates/delete-excel-tax-rate-request';
export const DELETE_EXCEL_TAX_RATE_SUCCESS =
  'tax-rates/delete-excel-tax-rate-success';
export const DELETE_EXCEL_TAX_RATE_FAILURE =
  'tax-rates/delete-excel-tax-rate-failure';

export const UPDATE_EXCEL_TAX_RATE_NAME_REQUEST =
  'tax-rates/update-excel-tax-rate-name-request';
export const UPDATE_EXCEL_TAX_RATE_NAME_SUCCESS =
  'tax-rates/update-excel-tax-rate-name-success';
export const UPDATE_EXCEL_TAX_RATE_NAME_FAILURE =
  'tax-rates/update-excel-tax-rate-name-failure';

export const CREATE_EXCEL_TAX_RATE_REQUEST =
  'tax-rates/create-excel-tax-rate-request';
export const CREATE_EXCEL_TAX_RATE_SUCCESS =
  'tax-rates/create-excel-tax-rate-success';
export const CREATE_EXCEL_TAX_RATE_FAILURE =
  'tax-rates/create-excel-tax-rate-failure';
